import { observer } from 'mobx-react'

import Modal from 'components/Modal'
import PublicVideoContent from 'components/PublicVideoContent'
import { SMALL_MODAL } from 'consts/modalStyles'
import { useWindowSize } from 'hooks'
import VideoModalStore from 'stores/VideoModalStore'

const MODAL_STYLE = {
  ...SMALL_MODAL,
  content: {
    ...SMALL_MODAL.content,
    padding: '0px',
    width: '95vw',
    maxHeight: '80vh',
  },
}

function PublicVideoModal() {
  const [windowSize] = useWindowSize()

  function handleClose() {
    VideoModalStore.setPublicVideo(null)
  }

  return (
    <div className="PublicVideoModal">
      <Modal
        isOpen={!!VideoModalStore.publicVideo}
        styleModal={windowSize <= 600 ? MODAL_STYLE : null}
        onRequestClose={handleClose}
      >
        <PublicVideoContent video={VideoModalStore.publicVideo} />
      </Modal>
    </div>
  )
}

export default observer(PublicVideoModal)
